import { useEffect, useRef } from "react";
import { useGoogleMap } from "@react-google-maps/api";
import { createPriceLayer } from "./priceCanvasLayer";

const noVisited = [];

export default function PriceMarkers({ properties, selectedId, visitedIds = noVisited, onSelect }) {
  const map = useGoogleMap();
  const layer = useRef(null);
  const latest = useRef({ properties, selectedId, visitedIds, onSelect });
  latest.current = { properties, selectedId, visitedIds, onSelect };
  useEffect(() => {
    if (!map) return;
    const current = latest.current;
    const instance = createPriceLayer(map, current.onSelect);
    layer.current = instance;
    instance.update(current.properties, current.selectedId, current.visitedIds, current.onSelect);
    return () => { instance.destroy(); layer.current = null; };
  }, [map]);
  useEffect(() => {
    layer.current?.update(properties, selectedId, visitedIds, onSelect);
  }, [properties, selectedId, visitedIds, onSelect]);
  return null;
}
